import PropTypes from "prop-types";
import { StyledBar } from "../../styles/StyledBar";
import { Row, Col, Container } from "react-grid-system";

export default function Bar({ children, bg, fullWidth, infobar = false }) {
	return (
		<StyledBar fluid bg={bg} infobar={infobar.toString()}>
			<Row>
				<Col>
					<Container>
						<Row>{fullWidth ? children : <Col sm={12}>{children}</Col>}</Row>
					</Container>
				</Col>
			</Row>
		</StyledBar>
	);
}

Bar.propTypes = {
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.node]),
	bg: PropTypes.string,
	fullWidth: PropTypes.bool,
	infobar: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};
